export default __webpack_public_path__ + "static/ai-customer-support-solutions-735d9cae7789b8a685bc28eb6e3f77f4.png";